module.exports = __webpack_public_path__ + "img/chatgreeting.907f2439.png";